import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'roechling',
} as IModuleProps;
